<template>
    <div class="banner">
      <a-carousel :autoplay="true" :dotPosition="'left'">
        <div><img :src="require('../../assets/bannerindex.jpg')" alt="" class="bannerImage"></div>
        <div style="position: relative;">
          <img :src="require('../../assets/bannerindex2.jpg')" alt="" class="bannerImage">
          <a target="_black" href="http://www.supersports.club" class="club-class">平台介绍</a>
          <a target="_black" href="http://mechanism.daoba.com/user/login?redirect=%2F&isClient=true" class="club-class" style="right:380px;">管理登录</a>
        </div>
      </a-carousel>
      <div class="bannerBottom">
        <div class="num-class">
          <p>{{$t('机构')}}</p>
          <p class="number">{{data.agencyNum}}</p>
        </div>
        <div class="num-class">
          <p>{{$t('教练')}}</p>
          <p class="number">{{data.staffNum}}</p>
        </div>
        <div class="num-class">
          <p>{{$t('运动员')}}</p>
          <p class="number">{{data.playerNum}}</p>
        </div>
        <div class="num-class">
          <p>{{$t('赛事')}}</p>
          <p class="number">{{data.matchNum}}</p>
        </div>
        <div class="num-class">
          <p>{{$t('参赛人次')}}</p>
          <p class="number">{{data.joinNum}}</p>
        </div>
        <div style="width: 200px;text-align: center;">
          <p>{{$t('比赛场次')}}</p>
          <p class="number ">{{data.pkNum}}</p>
        </div>
      </div>
    </div>
</template>

<script>

export default {
  name: 'Banner',
  components: {},
  mounted () {},
  data () {
    return {
      title: 'banner',
      data: {
        agencyNum: 0,
        pkNum: 0,
        matchNum: 0,
        playerNum: 0,
        joinNum: 0,
        staffNum: 0
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    getData () {
      this.$api.match.statisticalData().then(res => {
        if (res.status === 0) {
          this.data = res.data
        }
      }).catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.num-class{
  width: 200px;
  border-right: 1px solid #999;
  text-align: center;
}
.club-class{
  background: rgb(201, 162, 95) none repeat scroll 0% 0%;
  padding: 20px 30px;
  border-radius: 10px;
  position: absolute;
  bottom: 100px;
  right: 520px;
  color: black;
  z-index: 9999;
}
.banner{
  height:580px;
  position: relative;
  top:-71px;
  .bannerImage{
    height: 580px;
    width:100%;
  }
  .bannerBottom{
    position: absolute;
    display: flex;
    justify-content:space-around;
    align-items:center;
    bottom: 0px;
    width: 100%;
    padding: 15px 300px;
    background:rgba(0, 0, 0, 0.6);
    div{
      color: white;
      p{
        margin-bottom:0;
      }
      .number{
        font-size: 25px;
        font-weight: 600;
      }
    }
  }
}
.banner /deep/ .slick-slide {
  border: none;
}
.banner /deep/ .ant-carousel .slick-vertical .slick-slide{
  border: none;
  height: 580px;
}
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/layout/Banner.vue